$(document).ready(function() {
  $('th').each(function(col) {
	  sortOrder = 1;
      var arrData = $('table').find('tbody >tr:has(td)').get();

      arrData.sort(function(a, b) {
        var val1 = $(a).children('td').eq(col).text().toUpperCase();
        var val2 = $(b).children('td').eq(col).text().toUpperCase();
        if ($.isNumeric(val1) && $.isNumeric(val2))
          return sortOrder == 1 ? val1 - val2 : val2 - val1;
        else
          return (val1 < val2) ? -sortOrder : (val1 > val2) ? sortOrder : 0;
      });
      $.each(arrData, function(index, row) {
        $('tbody').append(row);
      });
    
    //end the js on ref column
    if ( $( this ).is( "#Ref" ) ) {
      document.getElementById("products").style.display = "table";
      return false;
    }
  });
});

document.addEventListener("DOMContentLoaded", function(event) { 
// This javascript just removes the leading zeros from the REF column for a nice touch.
  var table, rows, switching, i, x, y, shouldSwitch;
	table = document.getElementById("products");
	rows = table.rows;
    /*Loop through all table rows (except the
    first, which contains table headers):*/
    for (i = 1; i <= (rows.length - 1); i++) {
      //alert("Inloop" + i);
      /*Get the two elements you want to check */
      x = rows[i].getElementsByTagName("TD")[0].innerHTML.toLowerCase();
      //remove any leading zeros and write back
      var trimmed = x.replace(/\b0+/g, "");
        //alert("ah" + trimmed);
      table.rows[i].cells[0].innerHTML = trimmed;
    }
});